import { Button, Divider, Input, InputRef, Select, Space } from "antd";
import { CSSProperties, useEffect, useRef, useState } from "react";
import useDebounce from "@/hooks/useDebounce";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { BaseOptionType, SelectProps, DefaultOptionType } from "antd/es/select";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useGetBinListQuery } from "@/rtk-query/binQueries";
import { PlusOutlined } from "@ant-design/icons";
import { useGetPositionListQuery } from "@/rtk-query/positionQueries";

interface IPositionDropdownListProps {
  value?: string | number | null;
  onChangePos: (dataPosition: any) => void;
  disabled?: boolean;
  filter?: any;
  search?: string;
  className?: string;
  style?: CSSProperties;
  skip?: boolean;
}

const PositionDropdownList = ({ value, onChangePos, disabled, filter = {}, search = "", style, skip, className }: IPositionDropdownListProps) => {
  const newItemInputRef = useRef<InputRef>(null);
  const [searchPosition, setSearchPosition] = useState("");
  const [newPostion, setNewPostion] = useState<string>("");
  const [items, setItems] = useState<any[]>([""]);
  const searchPositionDebounce = useDebounce(searchPosition, 300);
  const { currentData: list, isFetching: isFetchingPosition } = useGetPositionListQuery(
    {
      ...filter,
      search: searchPositionDebounce,
    },
    { skip, refetchOnMountOrArgChange: true }
  );

  const checkDupPositionLowercase = (data: any[]) => {
    const dataFilterd: any[] = [];

    for (let i = 0; i < data.length; i++) {
      if (/[a-z]/.test(data[i].position)) {
        const dataUpper = data[i].position.toUpperCase();
        const haveValue = data.filter((item) => item.position.trim() === dataUpper.trim());
        const checkHavePos = dataFilterd.some((filterd) => filterd.position.trim() === dataUpper.trim());

        if (!checkHavePos) {
          if (haveValue.length > 0) {
            dataFilterd.push(haveValue[0]);
          } else {
            dataFilterd.push({
              ...data[i],
              position: dataUpper
            });
          }
        }
      } else {
        !dataFilterd.some((item) => item === data[i]) && dataFilterd.push(data[i]);
      }
    }
    return dataFilterd;
  };

  useEffect(() => {
    setSearchPosition(search);
  }, [search]);

  useEffect(() => {
    const data = checkDupPositionLowercase(list || []);
    setItems(data || [""]);
  }, [isFetchingPosition]);

  const dropdownStyle = {
    background: "#dfe3ef",
    padding: 0,
    borderRadius: 0,
    boxShadow: "inset 4px 4px 3px rgba(0, 0, 0, 0.03)",
    fontSize: 12,
    fontWeight: 600,
  };

  const addItem = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e.preventDefault();
    const newPos = newPostion.toLocaleUpperCase().trim();

    if (newPos.length <= 0) return;
    if (items.some((item) => item.position.toLocaleUpperCase().trim() === newPos)) {
      setNewPostion("");
      return;
    }

    setItems(items.length > 0 ? [...items, { position: newPos }] : [{ position: newPos }]);
    setNewPostion("");
    setTimeout(() => {
      newItemInputRef.current?.focus();
    }, 50);
  };

  const onChangeNewPostion = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewPostion(event.target.value);
  };

  return (
    <Select
      style={
        style || {
          color: "#234C66",
        }
      }
      className={className}
      placeholder="Type position..."
      showSearch
      // onSearch={(value) => setSearchPosition(value)}
      loading={isFetchingPosition}
      dropdownStyle={dropdownStyle}
      size="middle"
      popupClassName="customDropdownSelectAntd"
      allowClear
      onClear={() => onChangePos(null)}
      disabled={disabled}
      getPopupContainer={(triggerNode: HTMLElement) => triggerNode.parentNode as HTMLElement}
      optionFilterProp="label"
      value={value}
      onChange={(_, children: DefaultOptionType | undefined) => {
        onChangePos(children?.value || null);
      }}
      // eslint-disable-next-line react/no-unstable-nested-components
      dropdownRender={(menu) => (
        <div>
          {menu}
          <Divider style={{ margin: "8px 0" }} />
          <Space style={{ padding: "0 8px 4px" }}>
            <Input
              ref={newItemInputRef}
              placeholder="Please enter item"
              value={newPostion.toLocaleUpperCase()}
              onChange={onChangeNewPostion}
              onKeyDown={(e) => e.stopPropagation()}
            />
            <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
              Add
            </Button>
          </Space>
        </div>
      )}
      options={items.map((item) => ({
        value: item.position,
        label: item.position,
      }))}
    />
  );
};

export default PositionDropdownList;
